/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FollowTagMutationVariables = Types.Exact<{
  tag_id: Types.Scalars['String'];
}>;


export type FollowTagMutation = { __typename: 'Mutation', followTag: { __typename: 'TagFollow', id: string | null, tag_id: string | null, user_id: string | null } | null };


export const FollowTagDocument = gql`
    mutation followTag($tag_id: String!) {
  followTag(tag_id: $tag_id) {
    id
    tag_id
    user_id
  }
}
    `;
export type FollowTagMutationFn = Apollo.MutationFunction<FollowTagMutation, FollowTagMutationVariables>;

/**
 * __useFollowTagMutation__
 *
 * To run a mutation, you first call `useFollowTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followTagMutation, { data, loading, error }] = useFollowTagMutation({
 *   variables: {
 *      tag_id: // value for 'tag_id'
 *   },
 * });
 */
export function useFollowTagMutation(baseOptions?: Apollo.MutationHookOptions<FollowTagMutation, FollowTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowTagMutation, FollowTagMutationVariables>(FollowTagDocument, options);
      }
export type FollowTagMutationHookResult = ReturnType<typeof useFollowTagMutation>;
export type FollowTagMutationOptions = Apollo.BaseMutationOptions<FollowTagMutation, FollowTagMutationVariables>;